import React from 'react';
import { Star } from 'lucide-react';
import { Section } from './Shared';
export interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
  product?: string;
}
export const TestimonialCard = ({
  initials,
  name,
  location,
  text,
  product
}: TestimonialProps) => <div className="glass-panel p-6 md:p-8 rounded-2xl flex flex-col h-full border-brand-pink/15" data-id="element-329">
    <div className="flex items-center mb-4" data-id="element-330">
      <div className="w-9 h-9 md:w-12 md:h-12 rounded-full bg-brand-surfaceLight flex items-center justify-center text-brand-pink font-serif font-bold text-sm md:text-xl border border-brand-pink/30 mr-3 md:mr-4 shrink-0 shadow-sm" data-id="element-331">
        {initials}
      </div>
      <div data-id="element-332">
        <div className="flex text-brand-gold mb-1 text-[15px]" data-id="element-333">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-334" />)}
        </div>
        <div className="font-medium text-brand-text" data-id="element-335">{name}</div>
        <div className="text-xs text-brand-muted" data-id="element-336">
          {location} {product && `— ${product}`}
        </div>
      </div>
    </div>
    <p className="text-brand-text/90 italic flex-grow text-[13px] font-serif leading-relaxed" data-id="element-337">
      "{text}"
    </p>
  </div>;
export const InitialTestimonials = () => {
  const testimonials: TestimonialProps[] = [{
    initials: 'MG',
    name: 'María G.',
    location: 'Córdoba',
    text: 'Pensé que nunca iba a dejar de sentir ese peso en el pecho. La guía de escritura me ayudó a escribirle a mamá todo lo que me quedó guardado. Lloré, pero después sentí una paz que no sentía hace meses.'
  }, {
    initials: 'JL',
    name: 'Juliana L.',
    location: 'Buenos Aires',
    text: 'El ritual de 7 días me dio estructura en los momentos más difíciles. Tener algo concreto para hacer cada día cuando el dolor aparecía fue lo que más necesitaba.'
  }, {
    initials: 'CP',
    name: 'Carolina P.',
    location: 'La Plata',
    text: 'Lo que más me llegó fue la parte del legado. Entendí que honrar a mamá no es quedarme paralizada en el dolor, sino vivir con lo que ella me enseñó.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-338">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-[12px]" data-id="element-339">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-340" />)}
      </div>
    </Section>;
};
export const MoreTestimonials = () => {
  // We don't have extra testimonials in the prompt, so we can reuse or hide this section.
  // For now, I'll keep it with some generic positive feedback related to the topic.
  const testimonials = [{
    initials: 'AV',
    name: 'Ana V.',
    location: 'Mendoza',
    product: 'Santuario Digital',
    text: 'Las frases de contención son un abrazo al alma. Las leo cada vez que siento que no puedo más y me devuelven al centro.'
  }, {
    initials: 'SB',
    name: 'Sofía B.',
    location: 'CABA',
    product: 'Santuario Digital',
    text: 'El Cuaderno de Sanación me permitió darle un lugar a mi dolor. Es un espacio seguro donde puedo ser yo misma sin que nadie me juzgue.'
  }, {
    initials: 'ML',
    name: 'Marta L.',
    location: 'Rosario',
    product: 'Santuario Digital',
    text: 'Entender que no estoy traicionando a mi mamá por seguir con mi vida fue un antes y un después. Gracias por este material tan hermoso.'
  }, {
    initials: 'VR',
    name: 'Valeria R.',
    location: 'Neuquén',
    product: 'Santuario Digital',
    text: 'Me ayudó muchísimo a prepararme para el primer Día de la Madre sin ella. Tener un protocolo me dio mucha paz.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-341">
      <div className="text-center mb-12" data-id="element-342">
        <h2 className="md:text-4xl font-display font-bold mb-4 text-[24px] text-brand-pinkDark pt-[0px]" data-id="element-343">
          🌿 MÁS PERSONAS ACOMPAÑADAS
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-[12px] max-w-4xl mx-auto" data-id="element-344">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-345" />)}
      </div>
    </Section>;
};